<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Contratos dos Parceiros</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <b-button
              v-if="countFilter > 0"
              variant="primary"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </b-button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Parceiros</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0">Origem</th>
                    <th scope="col" class="border-0">Data do Cadastro</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(partner, index) in partnerContracts" :key="index">
                    <td></td>
                    <td class="text-left td-with-subs">
                      <div>{{ partner.Name | substring(50) }}</div>
                      <span>{{ partner.Identity | identity }}</span>
                    </td>
                    <td>{{ partner.SourceDescription }}</td>
                    <td>
                      <div>{{ partner.CreatedDate | date }}</div>
                      <span class="td-span-style">{{
                        partner.CreatedDate | date("HH:mm:ss")
                      }}</span>
                    </td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="
                              OpenResponsible(partner.CodeSolicitationV2)
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            :class="loadingDownload ? 'disabled' : ''"
                            v-on:click.stop="
                              GetContractSolicitation(partner.CodeSolicitationV2)
                            "
                          >
                            <template v-if="loadingDownload">
                              <loader
                                :small="true"
                                :isLoading="loadingDownload"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-long-arrow-alt-down mr-2"></i>
                              Download
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            v-if="
                              partner.IsAcceptedContract == 0 &&
                              $isAuthorize(
                                'Partner',
                                'DeleteContractSolicitation'
                              )
                            "
                            v-on:click="
                              ConfirmDeleteContractSolicitation(index)
                            "
                          >
                            <i class="fas fa-minus-square mr-2"></i> Cancelar
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      partnerContracts == undefined ||
                      partnerContracts == null ||
                      partnerContracts.length == 0
                    "
                  >
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            placeholder="Id"
            type="text"
            class="form-control"
            v-model="filter.Id"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsAcceptedContract" :value="null">
            <option :value="false" selected>Não assinado</option>
            <option :value="true">Assinado</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="mFormResponsible"
      title="Responsáveis"
      size="lg"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <loader :is-loading="loadingModal"></loader>
      <div v-if="!loadingModal">
        <div class="card-body p-0 pb-3 text-center">
          <table class="table mb-0">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th scope="col" class="border-0 text-left">Nome</th>
                <th scope="col" class="border-0 text-left">E-mail</th>
                <th scope="col" class="border-0 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(responsible, index) in responsibles" :key="index">
                <td class="text-left td-with-subs">
                  <div>{{ responsible.ResponsibleName | substring(50) }}</div>
                  <span>{{ responsible.ResponsibleIdentity | identity }}</span>
                </td>
                <td class="text-left">{{ responsible.ResponsibleEmail }}</td>
                <td class="text-left">
                  <span :class="[GetSpanClass(responsible.Status)]">{{
                    responsible.Status
                  }}</span>
                </td>
              </tr>
              <tr
                v-if="
                  responsibles == undefined ||
                  responsibles == null ||
                  responsibles.length == 0
                "
              >
                <td colspan="3">Sem registros</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "partner-contracts",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingDownload: false,
      listPendingSignedContract: false,
      countFilter: 1,
      labelName: "Parceiro",
      labelIdentity: "CPF/CNPJ",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Id: null,
        Identity: null,
        Name: null,
        IsAcceptedContract: false,
      },
      partnerContracts: [],
      responsibles: [],
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListPartnerContract();
    },
    "pagination.RowsPerPage": function () {
      this.ListPartnerContract();
    },
  },
  mounted() {
    if (this.$route.query.listPendingSignedContract == "true") {
      this.listPendingSignedContract = true;
      this.filter.IsAcceptedContract = false;
    }
    this.ListPartnerContract();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListPartnerContract();
    },
    ListPartnerContract: function () {
      this.countFilter = 1;
      if (hasValue(this.filter.Id)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Id": this.filter.Id == "" ? null : this.filter.Id,
          "Object.Identity": this.filter.Identity,
          "Object.Name": this.filter.Name,
          "Object.IsAcceptedContract": this.filter.IsAcceptedContract,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListPartnerContract", { params: data })
        .then((response) => {
          this.partnerContracts = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os parceiros",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      this.filter = {
        Id: null,
        Identity: null,
        Name: null,
        IsAcceptedContract: false,
      };
      this.ListPartnerContract();
    },
    OpenResponsible: function (codeSolicitation) {
      this.ListResponsible(codeSolicitation);
      this.$bvModal.show("mFormResponsible");
    },
    ListResponsible: function (codeSolicitation) {
      this.loadingModal = true;
      this.$store
        .dispatch("ListResponsiblePartner", {
          codeSolicitation: codeSolicitation,
        })
        .then((response) => {
          this.responsibles = response.Responsibles;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os responsáveis",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    GetContractSolicitation: function (codeSolicitation) {
      this.loadingDownload = true;
      this.$store
        .dispatch("GetContractSolicitationPartner", {
          codeSolicitation: codeSolicitation,
        })
        .then((response) => {
          if (hasValue(response.UrlContract)) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Contrato do parceiro"
            );
            window.open(response.UrlContract, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Falha ao gerar o contrato, tente novamente mais tarde.",
            "danger",
            "Contrato do parceiro",
            error
          );
        })
        .finally(() => {
          setTimeout(() => {
            $(".dropdown-menu").removeClass("show");
            this.loadingDownload = false;
          }, 250);
        });
    },
    ConfirmDeleteContractSolicitation(i) {
      let partner = this.partnerContracts[i];
      let identity = this.$options.filters.identity(partner.Identity);

      this.$makeMsgBox(
        `Você tem certeza que deseja CANCELAR a solicitação de assinatura de contrato no sDoc do parceiro ${partner.Name} (${identity}) ?`,
        "Confirmar ação",
        this.DeleteContractSolicitation,
        partner
      );
    },
    DeleteContractSolicitation: function (partner) {
      let partnerContractDelete = {
        Id: partner.Id,
        CodeSolicitationV2: partner.CodeSolicitationV2,
      };
      this.$store
        .dispatch("DeleteContractSolicitationPartner", partnerContractDelete)
        .then(() => {
          this.ListPartnerContract();
          this.$makeToast(
            "A solicitação de assinatura foi cancelada",
            "success",
            "Solicitação de assinatura cancelada"
          );
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Falha ao cancelar a solicitação de assinatura",
            error
          );
        });
    },
    GetSpanClass: function (status) {
      status = this.$options.filters.lower(status);
      let variation = "badge badge-warning";
      if (status == "assinado") {
        variation = "badge badge-success";
      } else if (status == "rejeitado") {
        variation = "badge badge-danger";
      }
      return variation;
    },
  },
};
</script>

<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 10pt;
  opacity: 0.75;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/partnerContracts.vue